<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header
      title="Jednostki/typy bułek"
      subtitle="Panel administratora"
      buttonLabel="Dodaj jednostkę/typ bułki"
      buttonLink="/admin/units/new"
      backButtonLabel="Wróć"
      backButtonLink="/admin/" />

    <d-row
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <form
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj nazwę jednostki/typu byłki"
          v-model="filters.search" />

        <d-button
          theme="success"
          outline
          class="text-nowrap ml-2"
          @click.prevent="searchWithFilters">Szukaj</d-button>

        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </form>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="thead-dark">
          <tr>
            <sortable-table-heading field="name" view="units" :column="orderColumn" :direction="orderDirection">Nazwa</sortable-table-heading>
            <sortable-table-heading field="type" view="units" :column="orderColumn" :direction="orderDirection">Typ</sortable-table-heading>
            <sortable-table-heading field="is_countable" view="units" :column="orderColumn" :direction="orderDirection">Policzalne?</sortable-table-heading>
            <sortable-table-heading field="preview_name" view="units" :column="orderColumn" :direction="orderDirection">Nazwa na podglądzie</sortable-table-heading>
            <th scope="col" class="border-0">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(unit, index) of units"
            :key="'unit-' + index">
            <td class="align-middle">
              <router-link :to="'/admin/units/' + unit.id">
                {{ unit.name }}
              </router-link>
            </td>
            <td class="align-middle">
              <template v-if="unit.type === 'roll'">Bułka</template>
              <template v-if="unit.type === 'unit'">Inny</template>
            </td>
            <td class="align-middle">
              <span class="text-success" v-if="unit.is_countable">Tak</span>
              <span class="text-danger" v-if="!unit.is_countable">Nie</span>
            </td>
            <td class="align-middle">
              {{ unit.preview_name }}
            </td>
            <td
              class="align-middle"
              style="width: 150px;">
              <d-button
                theme="dark"
                @click.native="$router.push('/admin/units/' + unit.id)"
                class="mr-2"
                title="Edytuj">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.native="removeUnit(unit.id)"
                title="Usuń">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="units.length === 0">
            <td
              colspan="5"
              class="text-center">
              Brak jednostek/typów bułek do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';

export default {
  name: 'units',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data() {
    return {
      units: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      filters: {
        search: ''
      }
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {};

      if (this.filters.search) {
        where.search = this.filters.search;
      }

      ListUtils.loadItemsData(this, {
        endpoint: '/system/units/items?page=' + this.currentPage,
        listField: 'units',
        pagination: true,
        params: {
          where,
          order: {
            column: this.orderColumn,
            direction: this.orderDirection
          }
        }
      });
    },
    removeUnit (unitID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/system/units/delete/',
        id: unitID,
        successTitle: 'Usunięto element',
        successText: 'Wybrany element został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć ten element?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie elementu nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: ''
      };

      this.loadFilteredData();
      this.$bus.emit('view-filters-reset');
    },
    searchWithFilters () {
      this.$bus.emit('pagination-reset');
      this.debouncedLoadFilteredData();
    }
  }
};
</script>
